<i18n lang='yml' src='../i18n/CertificateForm.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          {{type == 'new' ? `${$t('new_header')}` : `${$t('edit_header')}`}}
        </h4>
      </div>
    </div>
    <flash :message_type="message_type" :message_text="message_text"/>
    <div class="border-bottom" v-html="$t('section_description')"/>
    <Form ref="observer" v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
        <fieldset class="form-group border-bottom mt-4">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('title_english')" 
                    rules="required" 
                    v-slot="{ errors, field }"
                    v-model="certificate.title.en">
                    <label for="title_en"> 
                      {{$t('title_english')}} 
                    </label>
                    <span class="red">*</span>
                    <input :id="$t('title_english')" 
                      name="title_en"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="title_en_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </Field>   
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('title_french')" 
                    v-slot="{ errors, field }"
                    v-model="certificate.title.fr">
                    <label for="title_fr"> 
                      {{$t('title_french')}} 
                    </label>
                    <input :id="$t('title_french')" 
                      name="title_fr"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="title_fr_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </Field>   
                </div>
              </div>  

              <div class="form-group row">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('file_upload.label')" 
                    :rules="`required|image|size:2000`"
                    ref="provider"
                    v-slot="{ errors, handleChange }">
                    <label for="file_upload"> 
                      {{$t('file_upload.label')}} 
                    </label>
                    <span class="red">*</span>
                    <div v-html="$t('file_upload.guiding_text')"/>
                    <input :id="$t('file_upload.label')" 
                      @change="handleChange"
                      name="file_upload"
                      class="form-control" 
                      ref="file"
                      v-bind="field"
                      :class="{'is-invalid': errors[0]}"  
                      type="file">
                    <div class="invalid-feedback" id="file_upload" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </Field>
                </div>
              </div>

              <img v-if="type == 'edit' && image_url && ($refs.file && $refs.file.files.length == 0)" :src="image_url" width="300" height="auto"/>

              <div class="form-group row">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('name_position.label')"
                    rules="coordinates:true"
                    v-slot="{ errors, field }"
                    v-model="certificate.name_position">
                    <label for="title_fr"> 
                      {{$t('name_position.label')}} 
                    </label>
                    <div v-html="$t('name_position.guiding_text')"/>
                    <input :id="$t('name_position.label')" 
                      name="name_position"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="name_position_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </Field>   
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('date_position.label')"
                    rules="coordinates:true"
                    v-slot="{ errors, field }"
                    v-model="certificate.date_position">
                    <label for="date_position"> 
                      {{$t('date_position.label')}} 
                    </label>
                    <div v-html="$t('date_position.guiding_text')"/>
                    <input :id="$t('date_position.label')" 
                      name="date_position"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="date_position_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </Field>   
                </div>
              </div>

              <div class="form-group row">
                <div class="col-md-12 col-lg-9">
                  <Field 
                    :name="$t('point_size.label')"
                    rules="numeric"
                    v-slot="{ errors, field }"
                    v-model="certificate.point_size">
                    <label for="title_fr"> 
                      {{$t('point_size.label')}} 
                    </label>
                    <p> {{$t('point_size.guiding_text')}}</p>
                    <input :id="$t('point_size.label')" 
                      name="point_size"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field" 
                      type="text">
                    <div class="invalid-feedback" id="point_size_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </Field>   
                </div>
              </div>

            </div>
          </div>
        </fieldset>

        <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
          <span class="red mr-2">
            <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
          </span>
          {{ $t('error_warning') }}
        </div>

        <div class="btn-row d-flex">
          <button type="submit" class="btn btn-primary btn-success no-shadow">
            <font-awesome-icon :icon="['fa', 'save']" />
            {{ $t('save') }}
          </button>

          <a class="btn btn-light ml-auto" :href="base_path">
            <font-awesome-icon :icon="['fa', 'times']" />
            {{ $t('cancel') }}
          </a>
        </div>
    </Form>
  </div>
</template>
<script>
  import flash from '../../../../shared/flash_messages/components/Flash.vue';
  import '../../../../../javascripts/application/vee-validate-rules.js'
  import { Form, Field } from 'vee-validate'
  import { setErrorMessage } from '../../../../shared/typescripts/error.ts'

  export default {
    props: ['locale', 'base_path', 'type', 'certificate_data', 'image_url'],

    components: {
      flash,
      Form,
      Field
    },

    data() {
      return {
        certificate: {
          title: {en: '', fr: ''},
          name_position: null,
          date_position: null,
          point_size: 10,
          certificate_file: null
        },
        message_type: "",
        message_text: [],
        showErrorBanner: false
      }
    },

    mounted() {
      try {
        if(this.certificate_data){
          this.certificate = JSON.parse(this.certificate_data)
        }
      }
      catch(e){
        this.error = true;
      }
    },

    methods: {
      /// - Vee Validate methods - ///

      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors, true)
      },

      /// - Ajax - ///

      sendAjaxRequest(method, url, data) {
        const _vm = this
        $.ajax({
          type: method,
          url: `${url}`,
          processData: false, 
          contentType: false,
          data: data,
          success(data) {
            _vm.loading = false;
            if(data.error) {
              _vm.message_type = 'error'
              _vm.message_text.push(data.error)
            }
            else {
              window.location.replace(data.path);
            }
          },
          error(message) {
            _vm.loading = false;
            alert(_vm.$t('error_loading'));
          }
        });
      },
      submitUserInput() {
        debugger
        let formData = new FormData()
        if(this.$refs.file.files[0]) {
          formData.append("certificate[certificate_file]", this.$refs.file.files[0])
        }
        formData.append("certificate[title][en]", this.certificate.title.en)
        formData.append("certificate[title][fr]", this.certificate.title.fr)
        if(this.certificate.name_position) {
          formData.append("certificate[name_position]", this.certificate.name_position)
        }
        if(this.certificate.date_position) {
          formData.append("certificate[date_position]", this.certificate.date_position)
        }
        formData.append("certificate[point_size]", this.certificate.point_size)
        let sendType = 'POST'
        let path = `${this.base_path}`
        if(this.type == 'edit'){
          sendType = 'PUT'
          path = `${this.base_path}/${this.certificate.id}`
        }
        this.sendAjaxRequest(sendType, path, formData)
      }
    }

  }
</script>



